import { Card, ModalBody, ModalContent } from '@nextui-org/react'
import { FC, useEffect, useRef } from 'react'
import useHomeGradeStore from '../../store/home/useHomeGradeStore'
import { BaseDivider, BaseModal, BaseModalHeader } from '../common/Modal'
import { InsertTable } from '../common/Table'
import { ModalText } from '../common/Text'
import columns from './columns'
import { InitialInfoButton } from './InitialInfoButton'

export interface InitialInfoProps {
  onOpenChange: () => void
  isOpen: boolean
  isBack: () => void
}

export const InitialInfo: FC<InitialInfoProps> = ({ onOpenChange, isOpen, isBack }) => {
  const {
    insertData,
    tanksValues,
    setSendGradeData,
    tanksInfoBorderColor,
    typeError,
    requiredError,
  } = useHomeGradeStore()
  const inputRefs = useRef<(HTMLInputElement | null)[]>(Array(tanksValues.length).fill(null))

  useEffect(() => {
    setSendGradeData()
  }, [tanksValues, setSendGradeData])

  return (
    <BaseModal
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      size={'3xl'}
      onBrowserBack={isBack}
      data-testid="initial-info-modal"
      classNames={{
        wrapper: 'z-[1600]',
        backdrop: 'z-[1550]',
      }}
    >
      <ModalContent className="overflow-x-hidden">
        {(onClose) => (
          <>
            <BaseModalHeader title="Grade" description={ModalText('InsertTable')} />
            <ModalBody className="gap-0 min-h-[25rem] pl-6 sm:pl-10 pr-6 sm:pr-10 overflow-x-hidden overflow-y-auto">
              <BaseDivider />
              <Card className={`mt-3 ${tanksInfoBorderColor} border-opacity-60 min-h-[20rem]`}>
                <InsertTable
                  tanksValues={tanksValues}
                  inputRefs={inputRefs}
                  insertData={insertData}
                  columns={columns}
                  isGrade={true}
                />
              </Card>
              {typeError ? (
                <p className="m-0 text-sm font-semibold text-tdplmaroon">
                  *Please enter a natural number value in the STOCK field.
                </p>
              ) : (
                <p></p>
              )}
              {requiredError ? (
                <p className="m-0 text-sm font-semibold text-tdplmaroon">
                  *Stock field is required.
                </p>
              ) : (
                <p></p>
              )}
            </ModalBody>
            <InitialInfoButton isBack={isBack} onClose={onClose} />
          </>
        )}
      </ModalContent>
    </BaseModal>
  )
}
